import { definePreset, palette } from '@primeuix/themes'
import Nora from '@primeuix/themes/nora'

export const spdPreset = definePreset(Nora, {
  semantic: {
    primary: palette('#FF9D00'),
    colorScheme: {
      light: {
        primary: {
          color: '#FF9D00',
          contrastColor: '#1B2737',
          hoverColor: '#FFBB4D',
          activeColor: '#E08A00',
        },
        highlight: {
          background: '#FF9D00',
          focusBackground: '#E08A00',
          color: '#1B2737',
          focusColor: '#1B2737',
        },
        surface: {
          0: '#ffffff',
          50: '#f5f8fa',
          100: '#e7eef2',
          200: '#d5e0e7',
          300: '#b9c9d3',
          400: '#8aa0ae',
          500: '#647482',
          600: '#526575',
          700: '#2a3647',
          800: '#1b2737',
          900: '#15202c',
          950: '#0e1620',
        },
      },
    },
  },
  components: {
    accordion: {
      panel: {
        borderWidth: '0',
      },
      header: {
        borderRadius: '0',
        borderWidth: '0 0 1px 0',
        borderColor: '{surface.200}',
        background: '{surface.50}',
        hoverBackground: '{surface.100}',
        activeBackground: '{surface.0}',
        activeColor: '{surface.800}',
        padding: '0.75rem 1rem',
        fontWeight: '600',
        focusRing: {
          width: '0',
          shadow: 'none',
        },
        first: {
          topBorderRadius: '0',
          borderWidth: '0 0 1px 0',
        },
        last: {
          bottomBorderRadius: '0',
          activeBottomBorderRadius: '0',
        },
        toggleIcon: {
          color: '{surface.500}',
          activeColor: '{surface.500}',
        },
      },
      content: {
        borderWidth: '0',
        padding: '1rem',
        background: '{surface.0}',
      },
    },
    datepicker: {
      dropdown: {
        background: '{surface.0}',
        borderColor: '{surface.200}',
        color: '{surface.500}',
        hoverBackground: '{surface.50}',
        hoverBorderColor: '{surface.200}',
        activeBackground: '{surface.100}',
        activeBorderColor: '{surface.200}',
        borderRadius: '4px',
        focusRing: {
          width: '0',
          shadow: 'none',
        },
      },
    },
  },
})
